import { createContext, useContext } from "react";
import { isNil } from "../../shared";
export const StyleContext = /*#__PURE__*/createContext(undefined);
export const StyleProvider = StyleContext.Provider;
export function useStyleContext() {
  return useContext(StyleContext);
} // Do not remove the TS return type otherwise it will infer to any[] and do not emit any warnings.

export function useStyleProps(key) {
  const context = useStyleContext();

  if (!isNil(context)) {
    var _context$key;

    const props = !isNil(key) ? (_context$key = context[key]) !== null && _context$key !== void 0 ? _context$key : {} : {};
    return [props, true];
  }

  return [{}, false];
}